export default __webpack_public_path__ + "static/media/logo_noBackground.c729f060.png";